import React, { useEffect, useState } from 'react';
import MuxPlayer from '@mux/mux-player-react';
import { supabase } from '../services/supabase';
import '../styles/VODArchive.css';

const VODArchive = () => {
  const [vods, setVods] = useState([]);
  const [selectedVod, setSelectedVod] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchVods();
  }, []);

  const fetchVods = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('vod_archive')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      setVods(data || []);

      if (data && data.length > 0) {
        setSelectedVod(data[0]);
      }
    } catch (err) {
      console.error('Error fetching VODs:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  if (loading) {
    return <div className="vod-archive"><p>Loading VODs...</p></div>;
  }

  if (error) {
    return (
      <div className="vod-archive">
        <p className="error">Error loading VODs: {error}</p>
      </div>
    );
  }

  if (vods.length === 0) {
    return (
      <div className="vod-archive">
        <p>No VODs available yet</p>
      </div>
    );
  }

  return (
    <div className="vod-archive">
      <div className="vod-container">
        <div className="vod-player">
          {selectedVod ? (
            <>
              <MuxPlayer
                playbackId={selectedVod.playback_id}
                primaryColor="#FFFFFF"
                secondaryColor="#000000"
                style={{ width: '100%', aspectRatio: '16 / 9' }}
              />
              <div className="vod-info">
                <h2>{selectedVod.title}</h2>
                <p className="vod-date">{formatDate(selectedVod.created_at)}</p>
                {selectedVod.description && (
                  <p className="vod-description">{selectedVod.description}</p>
                )}
              </div>
            </>
          ) : (
            <div className="stream-placeholder">No VOD selected</div>
          )}
        </div>

        <div className="vod-list">
          <h3>Available VODs</h3>
          <div className="vod-items">
            {vods.map((vod) => (
              <div
                key={vod.id}
                className={`vod-item ${selectedVod?.id === vod.id ? 'active' : ''}`}
                onClick={() => setSelectedVod(vod)}
              >
                <div className="vod-item-title">{vod.title}</div>
                <div className="vod-item-date">{formatDate(vod.created_at)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VODArchive;
